import { ModelEntity, UtilsMisc, UtilsString } from '@pit/core';
import { JsonObject, JsonProperty } from 'json2typescript';
import { IDtoAddress } from '../interfaces/dto.address.interface';
import { IDtoShipmentProcessRecipient, ShipmentDeliveredTo, ShipmentDeliveredToConfirmation } from '../interfaces/dto.shipment.process.recipient.interface';
import { DtoAddress } from './dto.address';

// @dynamic
@JsonObject('DtoShipmentProcessRecipient')
export class DtoShipmentProcessRecipient extends ModelEntity implements IDtoShipmentProcessRecipient {

    constructor(initValues: Partial<IDtoShipmentProcessRecipient> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    @JsonProperty('deliveredTo', Number, true)
    public deliveredTo?: ShipmentDeliveredTo = ShipmentDeliveredTo.Unknown;

    @JsonProperty('deliveredToConfirmation', Number, true)
    public deliveredToConfirmation?: ShipmentDeliveredToConfirmation = ShipmentDeliveredToConfirmation.NotNecessary;

    @JsonProperty('name', String, true)
    public name?: string = null;

    @JsonProperty('signature', String, true)
    public signature?: string = null;

    @JsonProperty('address', DtoAddress, true)
    public address?: IDtoAddress = null;

    public get fullAddress(): string {
        return ((UtilsMisc.isNullOrUndefined(this.address) === true) ? null : this.address.fullAddress);
    }

    public get fullDescription(): string {
        return UtilsString.stringFormat('{0}, {1}', this.fullName, this.fullAddress);
    }

    public get fullName(): string {
        return this.name;
    }

}
